<app-modal class="create-modal">
    <ng-container modal-header>
        <h5 class="modal-title"
            *ngIf="!isEditMode; else editTitle">
            {{ 'admin.insertion-cycles.create-modal.title' | translate }}</h5>
        <ng-template #editTitle>
            <h5 class="modal-title">{{ 'admin.insertion-cycles.update-modal.title' | translate }}</h5>
        </ng-template>
    </ng-container>
    <ng-container modal-body>
        <div *ngIf="!isLoading; else loading">
            <form class="picklist-form"
                  [formGroup]="form">
                <div class="form-group row">
                    <div class="col s12">
                        <app-input formControlName="name"
                                   [formControl]="form.controls.name"
                                   [showErrors]="showValidations"
                                   placeholder="{{'admin.insertion-cycles.create-modal.name-input.placeholder' | translate }}"
                                   label="{{'admin.insertion-cycles.create-modal.name-input.label' | translate}}">
                        </app-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col s12 lines-row">
                        <app-picklist [source]="lines"
                                      [(target)]="insertionCycle.assignedLines"
                                      sourceHeader="{{'admin.insertion-cycles.create-modal.pick-list.leftHeader' | translate}}"
                                      targetHeader="{{'admin.insertion-cycles.create-modal.pick-list.rightHeader' | translate}}"
                                      infoLabel="{{'admin.insertion-cycles.create-modal.alert.message' | translate}}"
                                      (selectionChange)="onLinesChange($event)"></app-picklist>
                    </div>
                </div>
            </form>
        </div>
    </ng-container>
    <div class="footer" modal-footer>
        <app-button type="simple"
                    [disabled]="isLoading"
                    (click)="closeModal()">{{ 'generic.buttons.close' | translate }}
        </app-button>
        <div class="mutators" *ngIf="!isReadOnly">
            <app-button *ngIf="!isEditMode"
                        type="primary"
                        [disabled]="isLoading || !form.valid"
                        (click)="createInsertionCycle()">
                {{ 'admin.insertion-cycles.create-modal.button.create'| translate }}
            </app-button>
            <app-button *ngIf="isEditMode"
                        type="warning"
                        [disabled]="isLoading || !form.valid"
                        (click)="updateInsertionCycle()">
                {{ 'admin.insertion-cycles.create-modal.button.update'| translate }}
            </app-button>
            <app-button class="btn btn-danger"
                        *ngIf="isEditMode"
                        type="danger"
                        [disabled]="isLoading || insertionCycle.inUse"
                        (click)="deleteInsertionCycle()">
                {{ 'admin.insertion-cycles.create-modal.button.delete' | translate }}
            </app-button>
        </div>
    </div>
</app-modal>

<ng-template #loading>
    <div class="loading">
        <app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
    </div>
</ng-template>
